"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformModulePinConnection = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformSchematic_1 = require("./TransformSchematic");
const TransformNetConnection_1 = require("./TransformNetConnection");
class TransformModulePinConnection extends TransformObject_1.TransformObject {
    constructor(parent, props) {
        super(parent, {
            ...props,
            transformNetConnection: null,
        }, `${props.connection.moduleRef}::${props.connection.pinRef}`, new Set([TransformNetConnection_1.TransformNetConnection]));
        const connectionParent = this.requireParent(TransformSchematic_1.TransformSchematic);
        this._sharedData.transformNetConnection = new TransformNetConnection_1.TransformNetConnection(connectionParent, {
            position: props.position,
            moduleRef: props.connection.moduleRef,
            moduleName: props.connection.moduleName,
            pinRef: props.connection.pinRef,
            pinNumber: props.connection.pinNumber,
            pinPosition: props.connection.pinPosition,
            appliesNetName: props.connection.appliesNetName,
            skipPositionalCombobulation: props.connection.skipPositionalCombobulation,
        });
    }
    get dependencies() {
        return [this._sharedData.transformNetConnection];
    }
    compile() {
        return {
            netRef: this._sharedData.transformNetConnection.compiled,
            connection: this._sharedData.connection,
        };
    }
}
exports.TransformModulePinConnection = TransformModulePinConnection;
//# sourceMappingURL=TransformModulePinConnection.js.map